// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qg_a bhf_su bhf_kv bhf_kw","PostDetailRight__brandDaysPosts":"qg_b bhf_su bhf_kv bhf_kw"};